import * as React from 'react';
import { XCircleIcon } from 'lucide-react';
import { Card, CardContent } from 'components/ui/card';
import { useInvoiceStore } from 'pages/tracking-v2/invoice-details-page/hooks';
import { Formatter } from 'utils';

type Ref = {
  toggleOpen: () => void;
}

type Props = {
  defaultOpen?: boolean;
}

export type OriginPositionCardRef = Ref

export const OriginPositionCard = React.forwardRef<Ref, Props>(({
                                                                  defaultOpen = false,
                                                                }, ref) => {
  const { invoice } = useInvoiceStore();
  const [open, setOpen] = React.useState(defaultOpen);

  const supplierDescription = React.useMemo(() => {
    if (!invoice) return '';
    const { emitXnome, emitCnpj, emitXfant } = invoice;
    const document = emitCnpj ? Formatter.cnpj(emitCnpj) : '';
    return [emitXfant || emitXnome, document].join(' - ');
  }, [invoice]);

  React.useImperativeHandle(ref, () => {
    return {
      toggleOpen: () => setOpen(state => !state),
    };
  }, []);

  if (!open) {
    return null;
  }

  return (
    <Card className={'shadow-lg'}>
      <CardContent className={'py-6 px-6 relative text-[14px] max-w-[300px]'}>
        <button className={'absolute top-1 right-1'} onClick={() => setOpen(false)}>
          <XCircleIcon className={'w-5 h-5 stroke-gray-500'} />
        </button>
        <p className={'font-GilroySemibold text-[16px] mb-1'}>Remetente</p>
        <p className={'uppercase mb-4'}>{supplierDescription}</p>
        <p className={'font-GilroySemibold text-[16px] mb-1'}>Endereço</p>
        <p className={'uppercase'}>{invoice?.supplier?.address}</p>
      </CardContent>
    </Card>
  );
});
OriginPositionCard.displayName = 'OriginPositionCard';